<template>
    <card v-if="isArraySafe && visibility">
        <template v-if="fieldType === 'String' || fieldType === 'Number'">
            <div
                class="wrap"
                v-if="
                    fieldName !== 'Description' &&
                    fieldName !== 'FromDate' &&
                    fieldName !== 'ToDate'
                "
            >
                <b-form-group>
                    <label :for="id" class="head"
                        >{{ readableDisplayName }}
                        <span class="validate-error">{{
                            isRequired ? "*" : ""
                        }}</span></label
                    >

                    <ValidationProvider
                        :rules="isRequired ? 'required' : ''"
                        v-slot="{ errors }"
                        :name="readableDisplayName"
                    >
                        <template v-if="isEnumSelect">
                            <eb-select
                                :id="fieldName"
                                type="text"
                                :options="enumSelectOptions"
                                label="name"
                                :placeholder="`Select ${readableDisplayName}`"
                                :selected="enumSelectedOption"
                                @input="onEnumSelectLocal"
                            ></eb-select>
                            <!-- VeeValidate's required rule works reliably with native inputs -->
                            <input type="hidden" v-model="currField" />
                        </template>
                        <b-form-input
                            v-else
                            :type="fieldType === 'String' ? 'text' : 'number'"
                            :id="fieldName"
                            :value="value"
                            v-model="currField"
                            @change="onChangeLocal"
                            :placeholder="`Enter ${readableDisplayName}`"
                        ></b-form-input>
                        <span class="validate-error">{{
                            errors[0]
                        }}</span></ValidationProvider
                    >
                </b-form-group>
            </div>
            <div
                class="wrap"
                v-if="
                    fieldName !== 'Description' &&
                    fieldName !== 'ToDate' &&
                    fieldName == 'FromDate'
                "
            >
                <label class="head" :for="id"
                    >{{ readableDisplayName }} {{ isRequired ? "*" : "" }}</label
                >
                <b-input
                    :id="id"
                    type="date"
                    v-model="dateData"
                    @input="onChangeLocal"
                ></b-input>
            </div>
            <div
                class="wrap"
                v-if="
                    fieldName !== 'Description' &&
                    fieldName === 'ToDate' &&
                    fieldName !== 'FromDate'
                "
            >
                <label class="head" :for="id"
                    >{{ readableDisplayName }} {{ isRequired ? "*" : "" }}</label
                >
                <b-input
                    :id="id"
                    type="date"
                    v-model="dateData"
                    @input="onChangeLocal"
                ></b-input>
            </div>
            <div
                class="wrap"
                v-if="
                    fieldName === 'Description' &&
                    fieldName !== 'FromDate' &&
                    fieldName !== 'ToDate'
                "
            >
                <b-form-group>
                    <label class="head" :for="id"
                        >{{ readableDisplayName }}
                        <span class="validate-error">{{
                            isRequired ? "*" : ""
                        }}</span></label
                    >

                    <b-form-textarea
                        :id="id"
                        class="product-textarea"
                        debounce="1000"
                        v-model="textareavalue"
                        :placeholder="`Enter ${readableDisplayName}`"
                        @input="onChangeLocal"
                        rows="4"
                        no-resize
                    ></b-form-textarea>
                </b-form-group>
            </div>
        </template>
        <template v-else-if="fieldType === 'Object'">
            <div class="wrap" v-if="isUserTypeField">
                <strong
                    >{{ userSelectLabel }}
                    <span class="validate-error">{{
                        isRequired ? "*" : ""
                    }}</span></strong
                >
                <ValidationProvider
                    :rules="isRequired ? 'required' : ''"
                    v-slot="{ errors }"
                    name="Type"
                >
                    <eb-select
                        type="select"
                        v-model="selectedUser"
                        :options="userTypeList"
                        :label="userOptionLabel"
                        id="userNames"
                        :placeholder="`Select ${userSelectLabel}`"
                        :selected="selectedUser"
                        @input="onChangeLocal"
                    ></eb-select>
                    <span class="validate-error">{{
                        errors[0]
                    }}</span></ValidationProvider
                >
            </div>
            <div class="wrap" v-if="!isUserTypeField">
                <b-button
                    v-b-toggle="`'${fieldName}-id'`"
                    variant="outline-primary"
                    class="col-12 mb-2"
                    @click="setActive(index)"
                    >{{ readableDisplayName }}</b-button
                >
                <b-collapse
                    :id="`${fieldName}-id`"
                    class="mt-0"
                    :visible="active == index"
                >
                    <b-card>
                        <div v-for="item in subFields" :key="item._id">
                            <field
                                :id="item._id"
                                :value="value[item.attributeName]"
                                :fieldName="item.attributeName"
                                :fieldType="item.attributeValueType"
                                :level="level + 1"
                                :meta="
                                    meta.concat([
                                        {
                                            name: item.attributeName,
                                            type: item.attributeValueType,
                                        },
                                    ])
                                "
                                :onChange="onChange"
                                :UIConcern="item.UIConcern"
                                :enumValues="item.enumValues"
                                :valuesMap="valuesMap"
                            />
                        </div>
                    </b-card>
                </b-collapse>
            </div>
        </template>
        <template v-else-if="fieldType === 'Array'">
            <div class="wrap">
                <label class="head">{{ readableDisplayName }}</label>
                <array
                    :items="subFields"
                    :UIConcern="UIConcern"
                    @change="arrayChange"
                    :meta="meta"
                    :valuesMap="valuesMap"
                    :fieldName="fieldName"
                />
            </div>
        </template>
        <template
            v-else-if="fieldType === 'Boolean' || fieldType === 'boolean'"
        >
            <v-switch
                color="indigo"
                :value="true"
                :input-value="value"
                @change="onChangeLocal"
                :label="readableDisplayName"
            ></v-switch>
        </template>
    </card>
</template>

<style scoped>
.head {
    font-size: 1em;
    font-weight: 800;
}
.wrap {
    margin: 10px;
}
.product-textarea {
    height: auto !important;
}
</style>

<script>
import ArrayField from "@/components/Item/Array";
import Card from "@/components/Generics/Card.vue";
import ebSelect from "@/components/FormElements/Select.vue";
import { ValidationProvider } from "vee-validate";
export default {
    props: {
        id: {
            type: String,
            required: true,
        },
        value: {
            type: String | Number | Object | Array,
        },
        fieldType: {
            type: String,
            required: true,
            default: "String",
        },
        fieldName: {
            type: String,
            required: true,
        },
        displayName: {
            type: String,
            required: true,
        },
        subFields: {
            type: Array,
        },
        level: {
            type: Number,
            required: true,
        },
        meta: {
            type: Array,
            required: true,
        },
        active: {
            type: Number,
        },
        index: {
            type: Number,
        },
        onChange: {
            type: Function,
            required: true,
        },
        setActive: {
            type: Function,
        },
        UIConcern: {
            type: String,
        },
        enumValues: {
            type: Array,
            default: () => [],
        },
        arrayChange: {
            type: Function,
        },
        valuesMap: {
            type: Object,
        },
        isRequired: {
            type: Boolean,
            default: false,
        },
        visibility: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        castEnumToFieldType(raw) {
            if (raw === undefined || raw === null || raw === "") return raw;
            if (this.fieldType === "Number") return Number(raw);
            if (this.fieldType === "String") return String(raw);
            if (this.fieldType === "Boolean" || this.fieldType === "boolean") {
                if (typeof raw === "boolean") return raw;
                const normalized = String(raw).trim().toLowerCase();
                if (normalized === "true") return true;
                if (normalized === "false") return false;
            }
            return raw;
        },
        onEnumSelectLocal(option) {
            // eb-select emits the selected option object.
            const rawValue =
                option && Object.prototype.hasOwnProperty.call(option, "value")
                    ? option.value
                    : option;
            const casted = this.castEnumToFieldType(rawValue);
            this.currField = casted;
            this.onChangeLocal(casted);
        },
        onChangeLocal: function (params) {
            if (this.fieldType === "Boolean" && !params) {
                params = false;
            }
            this.onChange({
                meta: this.$props.meta,
                value: params,
            });
        },

        async getUsersByType(userType) {
            this.loading = true;
            await this.$store
                .dispatch("item/fetchAdminUsersByType", { userType })
                .then((data) => {
                    if (data.message) {
                        this.$toasted.error(data.message);
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                })
                .catch((err) => {
                    this.loading = false;
                });
        },
    },
    computed: {
        readableDisplayName() {
            const source = this.displayName || this.fieldName || "";
            const normalizedKey = String(source).replace(/\s+/g, "").toLowerCase();
            const labelMap = {
                issellable: "Available for Sale",
                isquotable: "Available for Quotation",
                isincludingtax: "Price Includes Tax",
            };
            if (labelMap[normalizedKey]) {
                return labelMap[normalizedKey];
            }
            const withSpaces = String(source)
                .replace(/_/g, " ")
                .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
                .replace(/\s+/g, " ")
                .trim();
            return withSpaces.replace(/\b\w/g, (ch) => ch.toUpperCase());
        },
        isEnumSelect() {
            return (
                this.UIConcern === "Select" &&
                Array.isArray(this.enumValues) &&
                this.enumValues.length > 0
            );
        },
        enumSelectOptions() {
            return (this.enumValues || []).map((v) => ({
                name: String(v),
                value: this.castEnumToFieldType(v),
            }));
        },
        enumSelectedOption() {
            if (!this.isEnumSelect) return null;
            const casted = this.castEnumToFieldType(this.currField);
            return (
                this.enumSelectOptions.find((opt) => opt.value === casted) ||
                null
            );
        },
        normalizedFieldName() {
            return String(this.fieldName || "").toLowerCase();
        },
        isAgentField() {
            return this.normalizedFieldName === "agent";
        },
        isDriverField() {
            return this.normalizedFieldName === "driver";
        },
        isDoctorField() {
            return this.normalizedFieldName === "doctor";
        },
        isUserTypeField() {
            return (
                this.isAgentField || this.isDriverField || this.isDoctorField
            );
        },
        userTypeCode() {
            if (this.isDriverField) return "DRIVER";
            if (this.isDoctorField) return "DOCTOR";
            if (this.isAgentField) return "AGENT";
            return "";
        },
        activeUserTypeCode() {
            return (
                this.$store.getters["item/GetAdminUsersType"] ||
                this.userTypeCode
            );
        },
        userSelectLabel() {
            if (this.activeUserTypeCode === "DRIVER") return "Driver";
            if (this.activeUserTypeCode === "DOCTOR") return "Doctor";
            return "Agent";
        },
        userOptionLabel() {
            return this.activeUserTypeCode === "DRIVER"
                ? "userName"
                : "fullName";
        },
        isArraySafe() {
            const { value, fieldType } = this;
            if (value) {
                this.onChange({
                    meta: this.$props.meta,
                    value: value,
                });
            }
            return (
                (fieldType === "Array" && value && value[0]) ||
                fieldType !== "Array"
            );
        },
        userTypeList() {
            let data = this.$store.getters["item/GetAdminUsersList"] || [];
            if (data && data.length > 0) {
                let users = [];
                data.map((obj) => {
                    const firstName =
                        (obj.name && (obj.name.first || obj.name.firstName)) ||
                        "";
                    const lastName =
                        (obj.name && (obj.name.last || obj.name.lastName)) ||
                        "";
                    const fullName = `${firstName} ${lastName}`.trim();
                    const fallbackName =
                        obj.fullName ||
                        obj.userName ||
                        (obj.authentication && obj.authentication.userName) ||
                        "";
                    users.push({
                        _id: obj._id,
                        userName:
                            (obj.authentication &&
                                obj.authentication.userName) ||
                            fallbackName,
                        fullName: fullName || fallbackName,
                        email:
                            (obj.authentication && obj.authentication.email) ||
                            obj.email,
                        phone:
                            (obj.authentication && obj.authentication.phone) ||
                            obj.phone,
                    });
                });
                return users;
            }
            return [];
        },
    },
    watch: {
        value(val) {
            this.currField = val;
        },
    },
    async mounted() {
        if (this.fieldType === "Object" && this.isUserTypeField) {
            await this.getUsersByType(this.userTypeCode);
        }
    },
    data() {
        return {
            textareavalue: this.value,
            selectedUser: "",
            currField: this.value,
        };
    },
    name: "field",
    components: {
        array: ArrayField,
        card: Card,
        ebSelect,
        ValidationProvider,
    },
};
</script>
